var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 12,
    fill: "#00BB8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2729_15892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 23.7501L14.334 20.8334H10.0007C9.77964 20.8334 9.56768 20.7456 9.4114 20.5893C9.25511 20.4331 9.16732 20.2211 9.16732 20.0001V10.9192C9.16732 10.6982 9.25511 10.4863 9.4114 10.33C9.56768 10.1737 9.77964 10.0859 10.0007 10.0859H23.334C23.555 10.0859 23.767 10.1737 23.9232 10.33C24.0795 10.4863 24.1673 10.6982 24.1673 10.9192V20.0001C24.1673 20.2211 24.0795 20.4331 23.9232 20.5893C23.767 20.7456 23.555 20.8334 23.334 20.8334H19.0006L16.6673 23.7501ZM18.1998 19.1667H22.5006V11.7526H10.834V19.1667H15.1348L16.6673 21.0817L18.1998 19.1667ZM6.66732 6.66675H20.834V8.33341H7.50065V17.5001H5.83398V7.50008C5.83398 7.27907 5.92178 7.06711 6.07806 6.91083C6.23434 6.75455 6.4463 6.66675 6.66732 6.66675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2729_15892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.20d2342a498f8292e14be52d4951f1c2.svg";
export { ForwardRef as ReactComponent };